export default __webpack_public_path__ + "static/media/no-image-logo.7213011d.svg";